import React, { useState } from "react";
import { OnChangeValue } from "react-select";
import CreatableSelect from "react-select/creatable";

interface Props {
  options: any[];
  optionLabelField?: string;
  optionValueField?: string;
  style?: React.CSSProperties | undefined;
  createOptionLabel?: string;
  placeholder?: string;
  onCreateOptionClick: (text?: string) => void;
  onChange: (event: any) => void;
  className?: string | undefined;
  invalid?: boolean;
  value: any;
}

export interface DropdownOption {
  label: string;
  value: string;
}

export function CreateableDropdown(props: Props) {
  const [autocompleteText, setAutocompleteText] = useState("");

  const handleSelectionChange = (event: OnChangeValue<DropdownOption, false>) => {
    if (event?.value === "create") props.onCreateOptionClick(autocompleteText);
    else props.onChange(event);
  };

  const handleCreateOption = (createTextValue: string) => {
    props.onCreateOptionClick(createTextValue);
  };

  const handleAutocompleteChange = (textValue: string) => {
    setAutocompleteText(textValue);
  };

  function formatOption(option: any) {
    let label = "";
    let value = "";

    if (typeof option === "string") {
      label = option;
      value = option;
    } else {
      if (props.optionLabelField) label = option[props.optionLabelField];
      if (props.optionValueField) value = option[props.optionValueField];
    }

    return { label: label, value: value };
  }

  function formatOptions(options: any[]) {
    const list = options.map((option) => {
      return formatOption(option);
    });

    return [
      ...list,
      {
        value: "create",
        label: `${props.createOptionLabel}...`,
      },
    ];
  }

  const selectStyles = {
    menuPortal: (styles: any) => ({ ...styles, zIndex: 9999999 }),
    menu: (styles: any) => ({ ...styles, zIndex: "9999999 !important" }),
    control: (styles: any) => ({
      ...styles,
      ...props.style,
      border: props.invalid && "1px solid #f44336",
      boxShadow: "none",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    }),
  };

  function formatCreateLabelCreator(value: string) {
    return `${props.createOptionLabel} "${value}"...`;
  }

  return (
    <CreatableSelect
      value={props.value ? formatOption(props.value) : undefined}
      isClearable
      onChange={handleSelectionChange}
      onInputChange={handleAutocompleteChange}
      onCreateOption={handleCreateOption}
      options={formatOptions(props.options)}
      styles={selectStyles}
      menuPortalTarget={document.body}
      formatCreateLabel={formatCreateLabelCreator}
      placeholder={props.placeholder}
    />
  );
}
